import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconPlus = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path d="M12.6667 7L12.666 10.666L16.3333 10.6667V12.6667L12.666 12.666L12.6667 16.3333H10.6667L10.666 12.666L7 12.6667V10.6667L10.666 10.666L10.6667 7H12.6667Z" />
      </svg>
    );
  }
);
